import script from "./BreadcrumbLink.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadcrumbLink.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__